import * as React from 'react';
import { createContext, useState, useContext, useLayoutEffect } from 'react';
const ThemeContext = createContext(undefined);
// Get initial theme from localStorage or system preference synchronously
const getInitialTheme = () => {
    if (typeof window === 'undefined')
        return 'light';
    const savedTheme = localStorage.getItem('chat-theme');
    if (savedTheme)
        return savedTheme;
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    return systemPrefersDark ? 'dark' : 'light';
};
// Apply theme to document immediately
const applyTheme = (theme) => {
    if (typeof document === 'undefined')
        return;
    if (theme === 'dark') {
        document.documentElement.classList.add('dark');
    }
    else {
        document.documentElement.classList.remove('dark');
    }
};
export const ThemeProvider = ({ children, }) => {
    // Initialize with the correct theme immediately
    const [theme, setTheme] = useState(getInitialTheme);
    // Apply theme immediately on mount and whenever it changes
    useLayoutEffect(() => {
        applyTheme(theme);
        localStorage.setItem('chat-theme', theme);
    }, [theme]);
    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
    };
    const isDark = theme === 'dark';
    return (React.createElement(ThemeContext.Provider, { value: { theme, toggleTheme, isDark } }, children));
};
export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
